
import { Vue, Component, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import AuditService from '@/services/audit.service';
import { EShopField } from '@/common/enum/shop';
import { ECarShopField } from '@/common/enum/carShop';

@Component({})
export default class extends Vue {
  visible = false;

  @Prop()
  multipleData?: any;

  @lazyInject(AuditService)
  protected auditService!: AuditService;

  EShopField = EShopField;

  ECarShopField = ECarShopField;

  atagName: any = '';

  init() {
    this.visible = true;
    if (
      Object.prototype.hasOwnProperty.call(
        this.multipleData,
        EShopField.MAIN_BUSINESS_ATAG_CODE,
      )
    ) {
      this.mainBusinessAtag(
        this.multipleData[EShopField.MAIN_BUSINESS_ATAG_CODE],
      );
    }
  }

  checkboxArray: any = {
    1: '洗车',
    2: '汽车保养',
    3: '钣金喷漆',
    4: '轮胎养护',
    5: '美容装潢',
    6: '汽车维修',
  };

  shopFields: any = {
    name: {
      labelName: '修改店铺名称',
    },
    address: {
      labelName: '修改地址明细',
    },
    start_time: {
      labelName: '修改开业时间',
    },
    advertiser_mobile_phone_number: {
      labelName: '修改广告主电话',
    },
    business_time: {
      labelName: '修改营业时间',
    },
    merchant_telephone: {
      labelName: '修改行业电话',
    },
    tels: {
      labelName: '修改营业电话',
    },
    manager_id: {
      labelName: '修改身份证信息',
    },
    shop_license: {
      labelName: '修改营业执照',
    },
    cover_pics: {
      labelName: '修改封面图片',
    },
    head_pics: {
      labelName: '修改店铺头图',
    },
    identity_num: {
      labelName: '修改企业法人身份证号',
    },
    market_name: {
      labelName: '修改市场',
    },
    pics: {
      labelName: '修改店铺图册',
    },
    join_videos: {
      labelName: '修改实拍视频',
    },
    shop_user_relations: {
      labelName: '修改店员信息',
    },
    other_qualifications: {
      labelName: '其他补充资质',
    },
    marketId: {
      labelName: '修改所属市场',
    },
    subName: {
      labelName: '修改门店简称',
    },
    sf_photos: {
      labelName: '修改店铺门头照',
    },
  };

  handleOk() {
    this.$emit('funModifyShop');
    this.visible = false;
  }

  handleCancel() {
    this.visible = false;
  }

  async mainBusinessAtag(val: any) {
    const params = {
      amapAtagId: val,
    };
    const res = await this.auditService.mainBusinessAtagList(params);
    if (res) {
      this.atagName = res.name;
    }
  }
}
